import useABTestValue from '@hooks/useABTestValue'

export type UseShouldShowDevtoolsOnProd = () => boolean

const useShouldShowDevtoolsOnProd: UseShouldShowDevtoolsOnProd = () =>
  [
    useABTestValue('showReactQueryDevtoolsOnProd'),
    useABTestValue('showTrackingDebugView'),
  ].some((value) => value === 'show')

export default useShouldShowDevtoolsOnProd
